import { Zap } from 'lucide-react';
import type * as React from 'react';
import { cn } from '../lib/cn.js';
import { Badge } from './badge.js';

export interface PremiumBadgeProps extends Omit<React.ComponentProps<'div'>, 'children'> {
  /** Libellé affiché. Toujours fourni par l'appelant, issu des traductions. */
  label: React.ReactNode;
}

/**
 * Ce qu'une offre payante apporte à un objet — un ticket à support prioritaire, par exemple.
 *
 * **Ce n'est pas un statut**, d'où un composant à part de `StatusBadge` : les six teintes de statut
 * disent où en est un objet, celui-ci dit ce qu'on lui doit. Dégradé du primaire à l'accent
 * secondaire, sur fond teinté et non plein, pour rester lisible dans les deux thèmes sans crier
 * plus fort que l'état du ticket posé à côté.
 */
export function PremiumBadge({ label, className, ...props }: PremiumBadgeProps) {
  return (
    <Badge
      variant="secondary"
      className={cn(
        'gap-1 border-primary/30 bg-transparent bg-gradient-to-r from-primary/15 to-accent-secondary/15 px-2 py-0.5 text-xs font-medium text-primary',
        className,
      )}
      {...props}
    >
      <Zap className="h-3 w-3 fill-current" aria-hidden="true" />
      {label}
    </Badge>
  );
}
